import { LogLevel } from "@azure/msal-browser";
import { authority, clientId, redirectUri, scopes } from "./apiurl";

export const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri
  },
  cache: {
    cacheLocation: "sessionStorage",
    // Browsers block third-party iframe storage access (Safari ITP, Chrome partitioning);
    // cookie fallback prevents monitor_window_timeout during silent token refresh.
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;

        switch (level) {
          case LogLevel.Error:
          case LogLevel.Info:
          case LogLevel.Verbose:
          case LogLevel.Warning:
          default:
            return;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes
};

export const graphConfig = {
  graphMeEndpoint:
    "https://graph.microsoft.com/v1.0/me?$select=id,displayName,givenName,surname,mail,userPrincipalName,jobTitle,department,officeLocation,mobilePhone,businessPhones",
  graphMemberOfEndpoint:
    "https://graph.microsoft.com/v1.0/me/memberOf?$select=id"
};